import { axiosInstance } from "@/config/axios-wrapper";
import { V2Response } from "@/types/api";
import { Chat } from "@/types/chat";


export const readChat = async (chatId: string) => {
  const response = await axiosInstance.post<V2Response<any>>(`/chats/${chatId}/read`);
  return response.data.result;
};

export const getOrganizationChats = async (
  data: { organizationId: string; q: string },
  { skip, limit = 20 }: { skip: number; limit?: number },
) => {
  const response = await axiosInstance.get<V2Response<any>>(
    `organizations/${data.organizationId}/chats?skip=${skip}&limit=${limit}&q=${data.q}`,
  );

  return response.data.result;
};

export const getUserChats = async (
  data: { userId: string; q: string },
  { skip, limit = 20 }: { skip: number; limit?: number },
) => {
  const response = await axiosInstance.get<V2Response<any>>(
    `users/${data.userId}/chats?skip=${skip}&limit=${limit}&q=${data.q}`,
  );

  return response.data.result;
};

export const getChatByJobAndJobseekerId = async (data: {
  jobseeker_id: string;
  job_id: string;
}) => {
  const response = await axiosInstance.get<V2Response<{
    [x: string]: any; chats: any[] 
}>>(
    `chats?jobseeker_id=${data.jobseeker_id}&job_id=${data.job_id}`,
  );
 console.log(response.data.result);
  if (response.data.result.length === 0) {
    return null;
  }

  return response.data.result.chats[0];
};

export const getChatById = async ({ chatId }: { chatId: string }) => {
  const response = await axiosInstance.get<V2Response<Chat>>(`/chats/${chatId}`);
  return response.data.result;
};

export const getMessagesByChatId = async ({ chatId, limit = 20, dir = "before", cursor }) => {
  try {
    const queryParams = new URLSearchParams({
      limit: limit.toString(),
      dir,
      ...(cursor ? { cursor } : {}),
    });

    const response = await axiosInstance.get<V2Response<any>>(`/chats/${chatId}/messages?${queryParams.toString()}`);
    return response.data.result;
  } catch (error) {
    console.error("Error fetching messages:", error);
    throw new Error("Failed to fetch messages. Please try again.");
  }
};

export const getLocatedMessagesByMessageId = async ({
  chat_id,
  message_id,
}: {
  chat_id: string;
  message_id: string;
}) => {
  const response = await axiosInstance.post<V2Response<any>>(`/chats/locateMessages`, {
    chat_id,
    message_id,
  });
  return response.data.result;
};
export const endChat = async ({ chatId }: { chatId: string }) => {
  const response = await axiosInstance.post<V2Response<any>>(`/chats/${chatId}/end`);
  return response.data.result;
};

export const updateEndedChat = async ({
  chatId,
  data,
}: {
  chatId: string;
  data: { ended: boolean };
}) => {
  const response = await axiosInstance.put<V2Response<any>>(`/chats/${chatId}/end`, data);
  return response.data.result;
};

interface OfferActionResult {
  status: string;
}

export const getChatAcceptOfferById = async (
  jobId: string,
  offerId: string,
): Promise<OfferActionResult> => {
  const response = await axiosInstance.post<V2Response<OfferActionResult>>(
    `/jobs/${jobId}/offer/${offerId}/accept`,
  );
  return response.data.result;
};

export const getChatDeclineOfferById = async (
  jobId: string,
  offerId: string,
): Promise<OfferActionResult> => {
  const response = await axiosInstance.post<V2Response<OfferActionResult>>(
    `/jobs/${jobId}/offer/${offerId}/decline`,
  );
  return response.data.result;
};

export const getChatAcceptMeetingById = async (organizationId: string, meetingId: string) => {
  const response = await axiosInstance.post<V2Response<any>>(
    `/organizations/${organizationId}/meetings/${meetingId}/accept`,
  );
  return response.data.result;
};

export const getChatDeclineMeetingById = async (organizationId: string, meetingId: string) => {
  const response = await axiosInstance.post<V2Response<any>>(
    `/organizations/${organizationId}/meetings/${meetingId}/reject`,
  );
  return response.data.result;
};

export const createJobOfferByJobId = async (jobId: string, offer: any) => {
  const response = await axiosInstance.post<V2Response<any>>(`/jobs/${jobId}/offer`, offer);
  return response.data.result;
};

export const updateJobOfferByJobId = async (jobId: string, offer: any) => {
  const response = await axiosInstance.post<V2Response<any>>(`/jobs/${jobId}/offer/${offer.id}`, offer);
  return response.data.result;
};
